import footer from '@/components/teacher/footer' //公用底部
import validateNewPhone from '@/components/teacher/user/validate-new-phone' //验证码手机号
export default [
    // {
    //     path: '',
    //     component: footer,
    //     children: [{
    //         path: 'center',
    //         component(resolve) {
    //             require(['@/components/teacher/user/center'], resolve)
    //         },
    //         meta: {
    //             title: '我的'
    //         }
    //     }]
    // },
    {
        path: 'center',
        component(resolve) {
            require(['@/components/teacher/user/center'], resolve)
        },
        meta: {
            title: '个人中心'
        }
    },
    {
        path: 'phone-succeed/:phone',
        component(resolve) {
            require(['@/components/teacher/user/phone-succeed'], resolve)
        },
        meta: {
            title: '修改成功'
        }
    },
    {
        path: 'modify-phone/:code',
        component(resolve) {
            require(['@/components/teacher/user/modify-phone'], resolve)
        },
        meta: {
            title: '修改手机号'
        }
    },

    {
        path: 'validate-new-phone/:phone',
        component(resolve) {
            require(['@/components/teacher/user/validate-new-phone'], resolve)
        },
        meta: {
            title: '修改手机号'
        }
    },
	{
		path:'reg',
		component(resolve) {
			require(['@/components/teacher/user/reg'], resolve)
		},
		meta: {  
			title : '账号绑定',
			isAuth : false,
		}
	},
	{
		path:'share/class/:schoolId/:classId',
		component(resolve) {
			require(['@/components/teacher/user/share-class'], resolve)
		},
		meta: {  
			title : '分享班级',
			isAuth : false
		}
	},
	{
		path:'scan/login/:token',
		component(resolve) {
			require(['@/components/teacher/user/scan-login'], resolve)
		},
		meta: {  
			title : '身份选择'
		}
	}
]


// WEBPACK FOOTER //
// ./src/router/teacher/user.js